import { render, staticRenderFns } from "./SoftwareComponentTypeAdd.vue?vue&type=template&id=79c81314&scoped=true&"
import script from "./SoftwareComponentTypeAdd.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentTypeAdd.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentTypeAdd.vue?vue&type=style&index=0&id=79c81314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c81314",
  null
  
)

export default component.exports